import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/normal/adapter/shopifys/show',
    name: 'adapterShopifysShow',
    component: () => import('@/views/adapter/shopifys/show.vue')
  },
  {
    path: '/normal',
    name: 'normal',
    component: () => import('@/layouts/Normal.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard'),
      },
      {
        path: 'oms/bargainsBulk',
        name: 'omsBargainsBulk',
        component: () => import('@/views/oms/bargainsBulk/index.vue'),
      },
      {
        path: 'oms/bargainsBulk/show/:id',
        name: 'omsBargainsBulkShow',
        component: () => import('@/views/oms/bargainsBulk/show.vue'),
      },
      {
        path: 'oms/bargains-same-customer',
        name: 'omsBargainsSameCustomer',
        component: () => import('@/views/oms/bargainsSameCustomer/index.vue?all'),
      },
      {
        path: 'oms/bargains',
        name: 'omsBargains',
        component: () => import('@/views/oms/bargains/index.vue?all'),
      },
      {
        path: 'oms/bargains/new',
        name: 'omsBargainsNew',
        component: () => import('@/views/oms/bargains/new.vue')
      },
      {
        path: 'oms/bargains/new-custom',
        name: 'omsBargainsNewCustom',
        component: () => import('@/views/oms/bargains/newCustom.vue')
      },
      {
        path: 'oms/bargains/new-bulk',
        name: 'omsBargainsNewBulk',
        component: () => import('@/views/oms/bargains/newBulk.vue')
      },
      {
        path: 'oms/bargains/new-wholesale',
        name: 'omsBargainsNewWholesale',
        component: () => import('@/views/oms/bargains/newWholesale.vue')
      },
      {
        path: 'oms/bargains/new-bulkOrder',
        name: 'omsBargainsNewBulkOrder',
        component: () => import('@/views/oms/bargains/newBulkOrder.vue')
      },
      {
        path: 'oms/bargains/new-payment',
        name: 'omsBargainsNewPayment',
        component: () => import('@/views/oms/bargains/newPayment.vue')
      },
      {
        path: 'oms/bargains/import',
        name: 'omsBargainsImport',
        component: () => import('@/views/oms/bargains/import.vue')
      },
      {
        path: 'oms/bargains/pdf',
        name: 'omsBargainsPdf',
        component: () => import('@/views/oms/bargains/pdf/index.vue')
      },
      {
        path: 'oms/bargains/import-payment',
        name: 'omsBargainsImportPayment',
        component: () => import('@/views/oms/bargains/importPayment.vue')
      },
      {
        path: 'oms/bargains/import-amazon',
        name: 'omsBargainsImportAmazon',
        component: () => import('@/views/oms/bargains/importAmazon.vue')
      },
      {
        path: 'oms/bargains/new-order/:uuid',
        name: 'omsBargainsNewOrder',
        component: () => import('@/views/oms/bargains/newOrder.vue')
      },
      {
        path: 'oms/bargains/new-delivery-requisition',
        name: 'omsBargainsNewDeliveryRequisition',
        component: () => import('@/views/oms/bargains/newDeliveryRequisition.vue')
      },
      {
        path: 'oms/bargains/new-delivery-beforehand',
        name: 'omsBargainsNewDeliveryBeforehand',
        component: () => import('@/views/oms/bargains/newDeliveryBeforehand.vue')
      },
      {
        path: 'oms/orders',
        name: 'omsOrders',
        component: () => import('@/views/oms/orders/index.vue')
      },
      {
        path: 'oms/replenishs',
        name: 'omsReplenishs',
        component: () => import('@/views/oms/replenishs/index.vue')
      },
      {
        path: 'oms/replenishs/new-bulk',
        name: 'omsReplenishsNewBulk',
        component: () => import('@/views/oms/replenishs/newBulk.vue')
      },
      {
        path: 'oms/replenishs/new-bulk2',
        name: 'omsReplenishsNewBulk2',
        component: () => import('@/views/oms/replenishs/newBulk2.vue')
      },
      {
        path: 'oms/replenishs/new-custom',
        name: 'omsReplenishsNewCustom',
        component: () => import('@/views/oms/replenishs/newCustom.vue')
      },
      {
        path: 'oms/replenishs/new-import/:shopId',
        name: 'omsReplenishsNewImport',
        component: () => import('@/views/oms/replenishs/newImport.vue')
      },
      //路径问好传参 解决指向同一页面 不加载页面
      {
        path: 'oms/unconfirms',
        name: 'omsUnconfirms',
        component: () => import('@/views/oms/bargains/index.vue?newly'),
      },
      {
        path: 'oms/pendings',
        name: 'omsPendings',
        component: () => import('@/views/oms/pendings/index.vue')
      },
      {
        path: 'oms/preparings',
        name: 'omsPreparings',
        component: () => import('@/views/oms/preparings/index.vue')
      },
      {
        path: 'oms/processings',
        name: 'omsProcessings',
        component: () => import('@/views/oms/processings/index.vue')
      },
      {
        path: 'oms/purchasings',
        name: 'omsPurchasings',
        component: () => import('@/views/oms/purchasings/index.vue')
      },
      {
        path: 'oms/customers',
        name: 'omsCustomers',
        component: () => import('@/views/oms/customers/index.vue')
      },
      {
        path: 'oms/customers/import',
        name: 'omsCustomersImport',
        component: () => import('@/views/oms/customers/import.vue')
      },
      {
        path: 'oms/customers/orders/:id',
        name: 'omsCustomersOrders',
        component: () => import('@/views/oms/customers/orders.vue')
      },
      {
        path: 'oms/customers/balances/:id',
        name: 'omsCustomersBalances',
        component: () => import('@/views/oms/customers/balances.vue')
      },
      {
        path: 'oms/customers/scores/:id',
        name: 'omsCustomersScores',
        component: () => import('@/views/oms/customers/scores.vue')
      },
      {
        path: 'oms/delivery-requisitions',
        name: 'omsDeliveryRequisitions',
        component: () => import('@/views/oms/deliveryRequisitions/index.vue')
      },


      //路径问好传参 解决指向同一页面 不加载页面
      {
        path: 'pms/purchases',
        name: 'pmsPurchases',
        component: () => import('@/views/pms/purchases/index.vue?all')
      },
      {
        path: 'pms/purchases/rework',
        name: 'pmsPurchasesRework',
        component: () => import('@/views/pms/purchases/rework.vue')
      },
      {
        path: 'pms/purchases/new',
        name: 'pmsPurchasesNew',
        component: () => import('@/views/pms/purchases/new.vue')
      },
      {
        path: 'pms/purchases/new-bulk',
        name: 'pmsPurchasesNewBulk',
        component: () => import('@/views/pms/purchases/newBulk.vue')
      },
      // {
      //   path: 'pms/purchases/new-quick',
      //   name: 'pmsPurchasesNewQuick',
      //   component: () => import('@/views/pms/purchases/newQuick.vue')
      // },
      {
        path: 'pms/purchases/new-quick-my',
        name: 'pmsPurchasesNewQuickMy',
        component: () => import('@/views/pms/purchases/newQuickMy.vue')
      },
      {
        path: 'pms/purchases/new-quick-supplier',
        name: 'pmsPurchasesNewQuickSupplier',
        component: () => import('@/views/pms/purchases/newQuickSupplier.vue')
      },
      {
        path: 'pms/purchases/copy-whole/:id',
        name: 'pmsPurchasesCopyWhole',
        component: () => import('@/views/pms/purchases/copyWhole.vue')
      },
      //路径问好传参 解决指向同一页面 不加载页面
      {
        path: 'pms/newlys',
        name: 'pmsNewlys',
        component: () => import('@/views/pms/purchases/index.vue?newly')
      },
      // ====
      {
        path: 'lms/pending-receives',
        name: 'lmsPendingReceives',
        component: () => import('@/views/lms/pendingReceives/index.vue')
      },
      {
        path: 'lms/pending-receives/manufacture',
        name: 'lmsPendingReceivesManufacture',
        component: () => import('@/views/lms/pendingReceives/manufacture/index.vue')
      },
      {
        path: 'lms/pending-receives/manufacture/show/:id',
        name: 'lmsPendingReceivesManufactureShow',
        component: () => import('@/views/lms/pendingReceives/manufacture/show.vue')
      },
      {
        path: 'lms/pending-receives/purchase',
        name: 'lmsPendingReceivesPurchase',
        component: () => import('@/views/lms/pendingReceives/purchase/index.vue')
      },
      {
        path: 'lms/pending-receives/purchase/show/:id',
        name: 'lmsPendingReceivesPurchaseShow',
        component: () => import('@/views/lms/pendingReceives/purchase/show.vue')
      },

      {
        path: 'lms/pending-qas',
        name: 'lmsPendingQAs',
        component: () => import('@/views/lms/pendingQAs/index.vue')
      },
      {
        path: 'lms/request-responses-agents',
        name: 'lmsRequestResponsesAgents',
        component: () => import('@/views/lms/requestResponses/agents/index.vue')
      },
      {
        path: 'lms/request-responses-express',
        name: 'lmsRequestResponsesExpress',
        component: () => import('@/views/lms/requestResponses/express/index.vue')
      },
      {
        path: 'lms/apply-trackings',
        name: 'lmsApplyTrackings',
        component: () => import('@/views/lms/applyTrackings/index.vue'),
      },
      {
        path: 'lms/apply-trackings/loop',
        name: 'lmsApplyTrackingsLoop',
        component: () => import('@/views/lms/applyTrackings/loop.vue')
      },
      {
        path: 'pms/suppliers',
        name: 'pmsSuppliers',
        component: () => import('@/views/pms/suppliers/index.vue')
      },
      {
        path: 'pms/reminders',
        name: 'pmsReminders',
        component: () => import('@/views/pms/reminders/index.vue')
      },
      {
        path: 'mms/pendings/orders',
        name: 'mmsPendingsOrders',
        component: () => import('@/views/mms/pendings/orders/index.vue')
      },
      {
        path: 'mms/pendings/orders2',
        name: 'mmsPendingsOrders2',
        component: () => import('@/views/mms/pendings/orders/index--.vue')
      },
      {
        path: 'mms/pendings/purchases',
        name: 'mmsPendingsPurchases',
        component: () => import('@/views/mms/pendings/purchases/index.vue')
      },
      {
        path: 'mms/requisitions',
        name: 'mmsRequisitions',
        component: () => import('@/views/mms/requisitions/index.vue')
      },
      {
        path: 'mms/requisitions/new',
        name: 'mmsRequisitionsNew',
        component: () => import('@/views/mms/requisitions/new.vue')
      },
      {
        path: 'mms/calculates',
        name: 'mmsCalculates',
        component: () => import('@/views/mms/calculates/index.vue')
      },
      {
        path: 'mms/procures',
        name: 'mmsProcures',
        component: () => import('@/views/mms/procures/index.vue')
      },
      {
        path: 'mms/procures/new',
        name: 'mmsProcuresNew',
        component: () => import('@/views/mms/procures/new.vue')
      },
      {
        path: 'mms/procures/import',
        name: 'mmsProcuresImport',
        component: () => import('@/views/mms/procures/import.vue')
      },
      {
        path: 'mms/qas',
        name: 'mmsQAs',
        component: () => import('@/views/mms/putins/index.vue?qas')
      },
      {
        path: 'mms/putins',
        name: 'mmsPutins',
        component: () => import('@/views/mms/putins/index.vue?putins')
      },
      {
        path: 'mms/inventories',
        name: 'mmsInventories',
        component: () => import('@/views/mms/inventories/index.vue')
      },
      {
        path: 'mms/inventories/check/:warehouseId',
        name: 'mmsInventoriesCheck',
        component: () => import('@/views/mms/inventories/check.vue')
      },
      {
        path: 'mms/inventories/import/:warehouseId',
        name: 'mmsInventoriesImport',
        component: () => import('@/views/mms/inventories/import.vue')
      },
      {
        path: 'mms/cashs',
        name: 'mmsCashs',
        component: () => import('@/views/mms/cashs/index.vue')
      },
      {
        path: 'mms/lack-statistics/count',
        name: 'mmsLackStatisticsCount',
        component: () => import('@/views/mms/lackStatistics/count.vue')
      },
      {
        path: 'mms/lack-statistics',
        name: 'mmsLackStatistics',
        component: () => import('@/views/mms/lackStatistics/index.vue')
      },
      {
        path: 'mms/stock-ins',
        name: 'mmsStockIns',
        component: () => import('@/views/mms/stockIns/index.vue')
      },
      {
        path: 'mms/stock-outs',
        name: 'mmsStockOuts',
        component: () => import('@/views/mms/stockOuts/index.vue')
      },
      {
        path: 'mms/snapshoots',
        name: 'mmsSnapshoots',
        component: () => import('@/views/mms/snapshoots/index.vue')
      },
      {
        path: 'mms/snapshoots/show/:snapDate',
        name: 'mmsSnapshootsShow',
        component: () => import('@/views/mms/snapshoots/show.vue')
      },
      {
        path: 'mms/allocates',
        name: 'mmsAllocates',
        component: () => import('@/views/mms/allocates/index.vue')
      },
      {
        path: 'mms/allocates/new-in/:warehouseId',
        name: 'mmsAllocatesNewIn',
        component: () => import('@/views/mms/allocates/newIn.vue')
      },
      {
        path: 'mms/returns',
        name: 'mmsReturns',
        component: () => import('@/views/mms/returns/index.vue')
      },
      {
        path: 'mms/returns/new/:warehouseId',
        name: 'mmsReturnsNew',
        component: () => import('@/views/mms/returns/new.vue')
      },
      {
        path: 'mms/materials',
        name: 'mmsMaterials',
        component: () => import('@/views/mms/materials/index.vue')
      },
      {
        path: 'mms/materials/new',
        name: 'mmsMaterialsNew',
        component: () => import('@/views/mms/materials/new.vue')
      },
      {
        path: 'mms/materials/import',
        name: 'mmsMaterialsImport',
        component: () => import('@/views/mms/materials/import.vue')
      },
      {
        path: 'mms/suppliers',
        name: 'mmsSuppliers',
        component: () => import('@/views/mms/suppliers/index.vue')
      },
      {
        path: 'mms/suppliers/import',
        name: 'mmsSuppliersImport',
        component: () => import('@/views/mms/suppliers/import.vue')
      },

      {
        path: 'mms/materials-search',
        name: 'mmsMaterialsSearch',
        component: () => import('@/views/mms/materialsSearch/index.vue')
      },
      {
        path: 'mes/workers',
        name: 'mesWorkers',
        component: () => import('@/views/mes/workers/index.vue')
      },
      {
        path: 'mes/workers/new-import',
        name: 'mesWorkersNewImport',
        component: () => import('@/views/mes/workers/newImport.vue')
      },
      {
        path: 'mes/orders',
        name: 'mesOrders',
        component: () => import('@/views/mes/orders/index.vue')
      },
      {
        path: 'mes/pending-dispatchs',
        name: 'mesPendingDispatchs',
        component: () => import('@/views/mes/pendingDispatchs/index.vue')
      },
      {
        path: 'mes/work-orders',
        name: 'mesWorkOrders',
        component: () => import('@/views/mes/workOrders/index.vue')
      },
      {
        path: 'mes/qas',
        name: 'mesQAs',
        component: () => import('@/views/mes/qas/index.vue')
      },
      {
        path: 'mes/tracks/order',
        name: 'mesTracksOrder',
        component: () => import('@/views/mes/tracks/order/index.vue')
      },
      {
        path: 'mes/tracks/work-order',
        name: 'mesTracksWorkOrder',
        component: () => import('@/views/mes/tracks/workOrder/index.vue')
      },
      {
        path: 'mes/tracks/worker',
        name: 'mesTracksWorker',
        component: () => import('@/views/mes/tracks/worker/index.vue')
      },
      {
        path: 'mes/manufactures',
        name: 'mesManufactures',
        component: () => import('@/views/mes/manufactures/index.vue')
      },
      {
        path: 'mes/schedule-analyse',
        name: 'mesScheduleAnalyse',
        component: () => import('@/views/mes/scheduleAnalyse/index.vue')
      },
      {
        path: 'mes/calc-expect-handOver',
        name: 'mesCalcExpectHandOver',
        component: () => import('@/views/mes/calcExpectHandOver/index.vue')
      },
      {
        path: 'wms/inventories',
        name: 'wmsInventories',
        component: () => import('@/views/wms/inventories/index.vue')
      },
      {
        path: 'wms/inventory-search/:productNo',
        name: 'wmsInventorySearch',
        component: () => import('@/views/wms/inventorySearch/index.vue')
      },
      {
        path: 'wms/inventory-search-schedule',
        name: 'wmsInventorySearchSchedule',
        component: () => import('@/views/wms/inventorySearchSchedule/index.vue')
      },
      {
        path: 'wms/inventories/check/:shopId',
        name: 'wmsInventoriesCheck',
        component: () => import('@/views/wms/inventories/check.vue')
      },
      {
        path: 'wms/inventories/import/:shopId',
        name: 'wmsInventoriesImport',
        component: () => import('@/views/wms/inventories/import.vue')
      },
      {
        path: 'wms/inventories/batch-stock-in/:shopId',
        name: 'wmsInventoriesBatchStockIn',
        component: () => import('@/views/wms/inventories/batchStockIn.vue')
      },
      {
        path: 'wms/inventories/batch-stock-out/:shopId',
        name: 'wmsInventoriesBatchStockOut',
        component: () => import('@/views/wms/inventories/batchStockOut.vue')
      },
      {
        path: 'wms/inventories/batch-stock-out-import/:shopId',
        name: 'wmsInventoriesBatchStockOutImport',
        component: () => import('@/views/wms/inventories/batchStockOutImport.vue')
      },
      {
        path: 'wms/pick-shelfs/delivery',
        name: 'wmsPickShelfsDelivery',
        component: () => import('@/views/wms/pickShelfs/delivery/index.vue')
      },
      {
        path: 'wms/pick-shelfs/allocate',
        name: 'wmsPickShelfsAllocate',
        component: () => import('@/views/wms/pickShelfs/allocate/index.vue')
      },
      {
        path: 'wms/pick-shelfs/remake',
        name: 'wmsPickShelfsRemake',
        component: () => import('@/views/wms/pickShelfs/remake/index.vue')
      },
      {
        path: 'wms/pick-shelfs/other',
        name: 'wmsPickShelfsOther',
        component: () => import('@/views/wms/pickShelfs/other/index.vue')
      },
      {
        path: 'wms/pick-lists',
        name: 'wmsPickLists',
        component: () => import('@/views/wms/pickLists/index.vue')
      },
      {
        path: 'wms/push-shelfs',
        name: 'wmsPushShelfs',
        component: () => import('@/views/wms/pushShelfs/index.vue')
      },
      {
        path: 'wms/stock-ins/count',
        name: 'wmsStockInsCount',
        component: () => import('@/views/wms/stockIns/count.vue')
      },
      {
        path: 'wms/stock-ins',
        name: 'wmsStockIns',
        component: () => import('@/views/wms/stockIns/index.vue')
      },
      {
        path: 'wms/stock-outs/count',
        name: 'wmsStockOutsCount',
        component: () => import('@/views/wms/stockOuts/count.vue')
      },
      {
        path: 'wms/stock-outs',
        name: 'wmsStockOuts',
        component: () => import('@/views/wms/stockOuts/index.vue')
      },
      {
        path: 'wms/allocates',
        name: 'wmsAllocates',
        component: () => import('@/views/wms/allocates/index.vue')
      },
      {
        path: 'wms/allocates/new-in/:shopId',
        name: 'wmsAllocatesNewIn',
        component: () => import('@/views/wms/allocates/newIn.vue')
      },
      {
        path: 'wms/damages',
        name: 'wmsDamages',
        component: () => import('@/views/wms/damages/index.vue')
      },
      {
        path: 'wms/snapshoots',
        name: 'wmsSnapshoots',
        component: () => import('@/views/wms/snapshoots/index.vue')
      },
      {
        path: 'wms/snapshoots/show/:snapDate',
        name: 'wmsSnapshootsShow',
        component: () => import('@/views/wms/snapshoots/show.vue')
      },


      {
        path: 'lms/pending-delivers-bulk',
        name: 'lmsPendingDeliversBulk',
        component: () => import('@/views/lms/pendingDeliversBulk/index.vue')
      },

      {
        path: 'lms/pending-delivers',
        name: 'lmsPendingDelivers',
        component: () => import('@/views/lms/pendingDelivers/index.vue')
      },
      {
        path: 'lms/request-delivers',
        name: 'lmsRequestDelivers',
        component: () => import('@/views/lms/requestDelivers/index.vue')
      },
      {
        path: 'lms/deliveries',
        name: 'lmsDeliveries',
        component: () => import('@/views/lms/deliveries/index.vue')
      },
      {
        path: 'lms/deliveries/loop',
        name: 'lmsDeliveriesLoop',
        component: () => import('@/views/lms/deliveries/loop.vue')
      },
      {
        path: 'lms/deliveries/picking-check',
        name: 'lmsDeliveriesPickingCheck',
        component: () => import('@/views/lms/deliveries/pickingCheck.vue')
      },
      {
        path: 'lms/deliveries/import-courier-cost',
        name: 'lmsDeliveriesImportCourierCost',
        component: () => import('@/views/lms/deliveries/importCourierCost.vue')
      },
      {
        path: 'lms/deliveries/import-tracking',
        name: 'lmsDeliveriesImportTracking',
        component: () => import('@/views/lms/deliveries/importTracking.vue')
      },
      {
        path: 'lms/scan-records',
        name: 'lmsScanRecords',
        component: () => import('@/views/lms/scanRecords/index.vue')
      },
      {
        path: 'lms/reworks',
        name: 'lmsReworks',
        component: () => import('@/views/lms/reworks/index.vue')
      },
      {
        path: 'lms/return-backs',
        name: 'lmsReturnBacks',
        component: () => import('@/views/lms/returnBacks/index.vue')
      },
      {
        path: 'schedules',
        name: 'schedules',
        component: () => import('@/views/schedules/index.vue')
      },
      {
        path: 'pdm/products',
        name: 'pdmProducts',
        component: () => import('@/views/pdm/products/index.vue')
      },
      {
        path: 'pdm/products/new',
        name: 'pdmProductsNew',
        component: () => import('@/views/pdm/products/new.vue')
      },
      {
        path: 'pdm/products/new-import',
        name: 'pdmProductsNewImport',
        component: () => import('@/views/pdm/products/newImport.vue')
      },
      {
        path: 'pdm/products/new-import-materials',
        name: 'pdmProductsNewImportMaterials',
        component: () => import('@/views/pdm/products/newImportMaterials.vue')
      },
      {
        path: 'pdm/products/new-import-phases',
        name: 'pdmProductsNewImportPhases',
        component: () => import('@/views/pdm/products/newImportPhases.vue')
      },
      {
        path: 'pdm/supplier-products',
        name: 'pdmSupplierProducts',
        component: () => import('@/views/pdm/supplierProducts/index.vue')
      },
      {
        path: 'pdm/quotations',
        name: 'pdmQuotations',
        component: () => import('@/views/pdm/quotations/index.vue')
      },
      {
        path: 'pdm/quotations/show/:id',
        name: 'pdmQuotationsShow',
        component: () => import('@/views/pdm/quotations/show.vue')
      },
      {
        path: 'pdm/quotations/new/:id',
        name: 'pdmQuotationsNew',
        component: () => import('@/views/pdm/quotations/new.vue')
      },
      {
        path: 'inquiries/customer',
        name: 'inquiriesCustomer',
        component: () => import('@/views/inquiries/customer/index.vue')
      },
      {
        path: 'inquiries/my',
        name: 'inquiriesMy',
        component: () => import('@/views/inquiries/my/index.vue')
      },
      {
        path: 'rents',
        name: 'rents',
        component: () => import('@/views/rents/index.vue')
      },
      {
        path: 'rents/new',
        name: 'rentsNew',
        component: () => import('@/views/rents/new.vue')
      },
      {
        path: 'rents/new-item/:id',
        name: 'rentsNewItem',
        component: () => import('@/views/rents/newItem.vue')
      },
      {
        path: 'rents/new-clean',
        name: 'rentsNewClean',
        component: () => import('@/views/rents/newClean.vue')
      },
      {
        path: 'sales-targets',
        name: 'salesTargets',
        component: () => import('@/views/salesTargets/index.vue')
      },
      {
        path: 'sales-targets/new',
        name: 'salesTargetsNew',
        component: () => import('@/views/salesTargets/new.vue')
      },
      {
        path: 'adapter/manual',
        name: 'adapterManual',
        component: () => import('@/views/adapter/manual/index.vue')
      },
      {
        path: 'adapter/request-responses',
        name: 'adapterRequestResponses',
        component: () => import('@/views/adapter/requestResponses/index.vue')
      },
      {
        path: 'adapter/taobaos',
        name: 'adapterTaobaos',
        component: () => import('@/views/adapter/taobaos/index.vue')
      },
      {
        path: 'adapter/taobaos/show',
        name: 'adapterTaobaosShow',
        component: () => import('@/views/adapter/taobaos/show.vue')
      },
      {
        path: 'adapter/amazons',
        name: 'adapterAmazons',
        component: () => import('@/views/adapter/amazons/index.vue')
      },
      {
        path: 'adapter/amazons/show',
        name: 'adapterAmazons/show',
        component: () => import('@/views/adapter/amazons/show.vue')
      },
      //===============
      {
        path: 'adapter/amazons/shipShow',
        name: 'perferenceLmsCouriersAmazonsShipShow',
        component: () => import('@/views/perference/lms/couriers/amazons/shipShow.vue')
      },
      //==================
      {
        path: 'adapter/shopifys',
        name: 'adapterShopifys',
        component: () => import('@/views/adapter/shopifys/index.vue')
      },
      // {
      //   path: 'adapter/shopifys/show',
      //   name: 'adapterShopifysShow',
      //   component: () => import('@/views/adapter/shopifys/show.vue')
      // },
      {
        path: 'adapter/shopifys/explain',
        name: 'adapterShopifysExplain',
        component: () => import('@/views/adapter/shopifys/explain.vue')
      },
      {
        path: 'adapter/ebays',
        name: 'adapterEbays',
        component: () => import('@/views/adapter/ebays/index.vue')
      },
      {
        path: 'adapter/aliexpresses',
        name: 'adapterAliexpresses',
        component: () => import('@/views/adapter/aliexpresses/index.vue')
      },
      {
        path: 'adapter/aliexpresses/show',
        name: 'adapterAliexpressesShow',
        component: () => import('@/views/adapter/aliexpresses/show.vue')
      },
      {
        path: 'downloads',
        name: 'downloads',
        component: () => import('@/views/downloads/index.vue')
      },
      {
        path: 'messages/send',
        name: 'messagesSend',
        component: () => import('@/views/messages/send.vue')
      },
      {
        path: 'messages/receive',
        name: 'messagesReceive',
        component: () => import('@/views/messages/receive.vue')
      },
      {
        path: 'sys-logs',
        name: 'sysLogs',
        component: () => import('@/views/sysLogs/index.vue')
      },
      // ==
      {
        path: 'to-do-lists/customer-returns',
        name: 'toDoListsCustomerReturns',
        component: () => import('@/views/toDoLists/customerReturns/index.vue')
      },
      {
        path: 'to-do-lists/customer-returns/new',
        name: 'toDoListsCustomerReturnsNew',
        component: () => import('@/views/toDoLists/customerReturns/new.vue')
      },
      {
        path: 'to-do-lists/customer-reworks',
        name: 'toDoListsCustomerReworks',
        component: () => import('@/views/toDoLists/customerReworks/index.vue')
      },
      {
        path: 'to-do-lists/customer-reminders',
        name: 'toDoListsCustomerReminders',
        component: () => import('@/views/toDoLists/customerReminders/index.vue')
      },

      {
        path: 'to-do-lists/order-cancel-pending-deals',
        name: 'toDoListsOrderCancelPendingDeals',
        component: () => import('@/views/toDoLists/orderCancelPendingDeals/index.vue')
      },
      {
        path: 'to-do-lists/my-reworks',
        name: 'toDoListsMyReworks',
        component: () => import('@/views/toDoLists/myReworks/index.vue')
      },
      {
        path: 'to-do-lists/synchronize-editions',
        name: 'toDoListsSynchronizeEditions',
        component: () => import('@/views/toDoLists/synchronizeEditions/index.vue')
      },
      {
        path: 'to-do-lists/hangs',
        name: 'toDoListsHangs',
        component: () => import('@/views/toDoLists/hangs/index.vue')
      },
      {
        path: 'to-do-lists/return-factory-reworks',
        name: 'toDoListsReturnFactoryReworks',
        component: () => import('@/views/toDoLists/returnFactoryReworks/index.vue')
      },
      {
        path: 'to-do-lists/phase-reworks',
        name: 'toDoListsPhaseReworks',
        component: () => import('@/views/toDoLists/phaseReworks/index.vue')
      },
      {
        path: 'to-do-lists/purchase-changes',
        name: 'toDoListsPurchaseChanges',
        component: () => import('@/views/toDoLists/purchaseChanges/index.vue')
      },
      // ==
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue')
      },
      {
        path: 'company',
        name: 'company',
        component: () => import('@/views/Company.vue')
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/Contact.vue')
      },
      //======

      {
        path: 'portals-user-sales-count-detail',
        name: 'portalsUserSalesCountDetail',
        component: () => import('@/views/portals/userSalesCountDetail.vue')
      },
      {
        path: 'portals-shap-sales-count-detail',
        name: 'portalsShopSalesCountDetail',
        component: () => import('@/views/portals/shopSalesCountDetail.vue')
      },
      {
        path: 'portals/user-sales-view-more',
        name: 'portalsUserSalesViewMore',
        component: () => import('@/views/portals/userSalesViewMore.vue')
      },
    ]
  },
  {
    path: '/set',
    name: 'set',
    component: () => import('@/layouts/Perference.vue'),
    children: [
      {
        path: 'perference/users',
        name: 'perferenceUsers',
        component: () => import('@/views/perference/users/index.vue')
      },
      {
        path: 'perference/auth-templates',
        name: 'perferenceAuthTemplates',
        component: () => import('@/views/perference/authTemplates/index.vue')
      },
      {
        path: 'perference/auth-templates/new',
        name: 'perferenceAuthTemplatesNew',
        component: () => import('@/views/perference/authTemplates/new.vue')
      },
      {
        path: 'perference/shops',
        name: 'perferenceShops',
        component: () => import('@/views/perference/shops/index.vue')
      },
      {
        path: 'perference/pdm/categories',
        name: 'perferencePdmCategories',
        component: () => import('@/views/perference/pdm/categories/index.vue')
      },
      {
        path: 'perference/pdm/units',
        name: 'perferencePdmUnits',
        component: () => import('@/views/perference/pdm/units/index.vue')
      },
      {
        path: 'perference/pdm/colors',
        name: 'perferencePdmColors',
        component: () => import('@/views/perference/pdm/colors/index.vue')
      },
      {
        path: 'perference/pdm/colors/import',
        name: 'perferencePdmColorsImport',
        component: () => import('@/views/perference/pdm/colors/import.vue')
      },
      {
        path: 'perference/pdm/sizes',
        name: 'perferencePdmSizes',
        component: () => import('@/views/perference/pdm/sizes/index.vue')
      },
      {
        path: 'perference/pdm/attributes',
        name: 'perferencePdmAttributes',
        component: () => import('@/views/perference/pdm/attributes/index.vue')
      },
      {
        path: 'perference/pdm/labels',
        name: 'perferencePdmLabels',
        component: () => import('@/views/perference/pdm/labels/index.vue')
      },
      {
        path: 'perference/pdm/brands',
        name: 'perferencePdmBrands',
        component: () => import('@/views/perference/pdm/brands/index.vue')
      },
      {
        path: 'perference/pdm/tag-templates',
        name: 'perferencePdmTagTemplates',
        component: () => import('@/views/perference/pdm/tagTemplates/index.vue')
      },
      {
        path: 'perference/pdm/tag-templates/new',
        name: 'perferencePdmTagTemplatesNew',
        component: () => import('@/views/perference/pdm/tagTemplates/new.vue')
      },
      {
        path: 'perference/pdm/tag-templates/edit/:id',
        name: 'perferencePdmTagTemplatesEdit',
        component: () => import('@/views/perference/pdm/tagTemplates/edit.vue')
      },
      {
        path: 'perference/pdm/craftwork-templates',
        name: 'perferencePdmCraftworkTemplates',
        component: () => import('@/views/perference/pdm/craftworkTemplates/index.vue')
      },
      {
        path: 'perference/pdm/craftwork-templates/new',
        name: 'perferencePdmCraftworkTemplatesNew',
        component: () => import('@/views/perference/pdm/craftworkTemplates/new.vue')
      },
      {
        path: 'perference/pdm/craftwork-templates/edit/:id',
        name: 'perferencePdmCraftworkTemplatesEdit',
        component: () => import('@/views/perference/pdm/craftworkTemplates/edit.vue')
      },
      {
        path: 'perference/oms/currencies',
        name: 'perferenceOmsCurrencies',
        component: () => import('@/views/perference/oms/currencies/index.vue')
      },
      {
        path: 'perference/oms/groups',
        name: 'perferenceOmsGroups',
        component: () => import('@/views/perference/oms/groups/index.vue')
      },
      {
        path: 'perference/oms/customer-groups',
        name: 'perferenceOmsCustomerGroups',
        component: () => import('@/views/perference/oms/customerGroups/index.vue')
      },

      {
        path: 'perference/oms/bargain-templates',
        name: 'perferenceOmsBargainTemplates',
        component: () => import('@/views/perference/oms/bargainTemplates/index.vue')
      },
      {
        path: 'perference/oms/bargain-templates/new',
        name: 'perferenceOmsBargainTemplatesNew',
        component: () => import('@/views/perference/oms/bargainTemplates/new.vue')
      },
      {
        path: 'perference/oms/bargain-templates/edit/:id',
        name: 'perferenceOmsBargainTemplatesEdit',
        component: () => import('@/views/perference/oms/bargainTemplates/edit.vue')
      },
      {
        path: 'perference/oms/remark-templates',
        name: 'perferenceOmsRemarkTemplates',
        component: () => import('@/views/perference/oms/remarkTemplates/index.vue')
      },
      {
        path: 'perference/oms/remark-templates/new',
        name: 'perferenceOmsRemarkTemplatesNew',
        component: () => import('@/views/perference/oms/remarkTemplates/new.vue')
      },
      {
        path: 'perference/oms/remark-templates/edit/:id',
        name: 'perferenceOmsRemarkTemplatesEdit',
        component: () => import('@/views/perference/oms/remarkTemplates/edit.vue')
      },
      {
        path: 'perference/pay-methods',
        name: 'perferencePayMethods',
        component: () => import('@/views/perference/payMethods/index.vue')
      },
      {
        path: 'perference/mms/subjects',
        name: 'perferenceMmsSubjects',
        component: () => import('@/views/perference/mms/subjects/index.vue')
      },
      {
        path: 'perference/mes/phase-groups',
        name: 'perferenceMesPhaseGroups',
        component: () => import('@/views/perference/mes/phaseGroups/index.vue')
      },
      {
        path: 'perference/mes/phases',
        name: 'perferenceMesPhases',
        component: () => import('@/views/perference/mes/phases/index.vue')
      },
      {
        path: 'perference/mes/rework-types',
        name: 'perferenceMesReworkTypes',
        component: () => import('@/views/perference/mes/reworkTypes/index.vue')
      },
      {
        path: 'perference/mes/factories',
        name: 'perferenceMesFactories',
        component: () => import('@/views/perference/mes/factories/index.vue')
      },

      {
        path: 'perference/mes/work-order-templates',
        name: 'perferenceMesWorkOrderTemplates',
        component: () => import('@/views/perference/mes/workOrderTemplates/index.vue')
      },
      {
        path: 'perference/mes/work-order-templates/new',
        name: 'perferenceMesWorkOrderTemplatesNew',
        component: () => import('@/views/perference/mes/workOrderTemplates/new.vue')
      },
      {
        path: 'perference/mes/work-order-templates/edit/:id',
        name: 'perferenceMesWorkOrderTemplatesEdit',
        component: () => import('@/views/perference/mes/workOrderTemplates/edit.vue')
      },
      {
        path: 'perference/mes/phase-templates',
        name: 'perferenceMesPhaseTemplates',
        component: () => import('@/views/perference/mes/phaseTemplates/index.vue')
      },
      {
        path: 'perference/mms/warehouses',
        name: 'perferenceMmsWarehouses',
        component: () => import('@/views/perference/mms/warehouses/index.vue')
      },

      {
        path: 'perference/wms/warehouses',
        name: 'perferenceWmsWarehouses',
        component: () => import('@/views/perference/wms/warehouses/index.vue')
      },
      {
        path: 'perference/wms/warehouses/show/:id',
        name: 'perferenceWmsWarehousesShow',
        component: () => import('@/views/perference/wms/warehouses/show.vue')
      },
      {
        path: 'perference/wms/stock-in-types',
        name: 'perferenceWmsStockInTypes',
        component: () => import('@/views/perference/wms/stockInTypes/index.vue')
      },
      {
        path: 'perference/wms/stock-out-types',
        name: 'perferenceWmsStockOutTypes',
        component: () => import('@/views/perference/wms/stockOutTypes/index.vue')
      },
      {
        path: 'perference/lms/couriers',
        name: 'perferenceLmsCouriers',
        component: () => import('@/views/perference/lms/couriers/index.vue')
      },

      {
        path: 'perference/lms/expresses',
        name: 'perferenceLmsExpresses',
        component: () => import('@/views/perference/lms/expresses/index.vue')
      },
      {
        path: 'perference/rent-templates',
        name: 'perferenceRentTemplates',
        component: () => import('@/views/perference/rentTemplates/index.vue')
      },
      {
        path: 'perference/rent-templates/new',
        name: 'perferenceRentTemplatesNew',
        component: () => import('@/views/perference/rentTemplates/new.vue')
      },
      {
        path: 'perference/rent-templates/edit/:id',
        name: 'perferenceRentTemplatesEdit',
        component: () => import('@/views/perference/rentTemplates/edit.vue')
      },
      {
        path: 'perference/schedule-types',
        name: 'perferenceScheduleTypes',
        component: () => import('@/views/perference/scheduleTypes/index.vue')
      },
      {
        path: 'perference/settings',
        name: 'perferenceSettings',
        component: () => import('@/views/perference/settings/index.vue')
      },
    ]
  },
  {
    path: '/fnReport',
    name: 'fnReport',
    component: () => import('@/layouts/FNReport.vue'),
    children: [
      {
        path: 'fn-reports',
        name: 'fnReports',
        component: () => import('@/views/fnReports/index.vue')
      },
      {
        path: 'fn-reports/verifies/bargains',
        name: 'fnReportsVerifiesBargains',
        component: () => import('@/views/fnReports/verifies/bargains/index.vue')
      },
      {
        path: 'fn-reports/verifies/customer-balances',
        name: 'fnReportsVerifiesCustomerBalances',
        component: () => import('@/views/fnReports/verifies/customerBalances/index.vue')
      },
      {
        path: 'fn-reports/verifies/pending-delivers',
        name: 'fnReportsVerifiesPendingDelivers',
        component: () => import('@/views/fnReports/verifies/pendingDelivers/index.vue')
      },
      {
        path: 'fn-reports/customer-settlements',
        name: 'fnReportsCustomerSettlements',
        component: () => import('@/views/fnReports/customerSettlements/index.vue')
      },
      {
        path: 'fn-reports/customer-settlements/new/:title',
        name: 'fnReportsCustomerSettlementsNew',
        component: () => import('@/views/fnReports/customerSettlements/new.vue')
      },
      {
        path: 'fn-reports/customer-settlements/intelligent-check/:id',
        name: 'fnReportsCustomerSettlementsIntelligentCheck',
        component: () => import('@/views/fnReports/customerSettlements/intelligentCheck.vue')
      },
      {
        path: 'fn-reports/supplier-settlements',
        name: 'fnReportsSupplierSettlements',
        component: () => import('@/views/fnReports/supplierSettlements/index.vue')
      },
      {
        path: 'fn-reports/supplier-settlements/new/:title',
        name: 'fnReportsSupplierSettlementsNew',
        component: () => import('@/views/fnReports/supplierSettlements/new.vue')
      },
      {
        path: 'fn-reports/supplier-settlements/intelligent-check/:id',
        name: 'fnReportSupplierSettlementsIntelligentCheck',
        component: () => import('@/views/fnReports/supplierSettlements/intelligentCheck.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/agents',
        name: 'fnReportsDeliverSettlementsAgents',
        component: () => import('@/views/fnReports/deliverSettlements/agents/index.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/agents/new/:title',
        name: 'fnReportsDeliverSettlementsAgentsNew',
        component: () => import('@/views/fnReports/deliverSettlements/agents/new.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/agents/import/:id',
        name: 'fnReportsDeliverSettlementsAgentsImport',
        component: () => import('@/views/fnReports/deliverSettlements/agents/import.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/expresses',
        name: 'fnReportsDeliverSettlementsExpresses',
        component: () => import('@/views/fnReports/deliverSettlements/expresses/index.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/expresses/new/:title',
        name: 'fnReportsDeliverSettlementsExpressesNew',
        component: () => import('@/views/fnReports/deliverSettlements/expresses/new.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/expresses/import/:id',
        name: 'fnReportsDeliverSettlementsExpressesImport',
        component: () => import('@/views/fnReports/deliverSettlements/expresses/import.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/carry',
        name: 'fnReportsDeliverSettlementsCarry',
        component: () => import('@/views/fnReports/deliverSettlements/carry/index.vue')
      },
      {
        path: 'fn-reports/deliver-settlements/carry/new/:title',
        name: 'fnReportsDeliverSettlementsCarryNew',
        component: () => import('@/views/fnReports/deliverSettlements/carry/new.vue')
      },

      {
        path: 'fn-reports/deliver-checks/agents',
        name: 'fnReportsDeliverChecksAgents',
        component: () => import('@/views/fnReports/deliverChecks/agents/index.vue')
      },
      {
        path: 'fn-reports/deliver-checks/agents/import/:id',
        name: 'fnReportsDeliverChecksAgentsImport',
        component: () => import('@/views/fnReports/deliverChecks/agents/import.vue')
      },
      {
        path: 'fn-reports/deliver-checks/agents/line-item/:id',
        name: 'fnReportsDeliverChecksAgentsLineItem',
        component: () => import('@/views/fnReports/deliverChecks/agents/lineItem.vue')
      },


      {
        path: 'fn-reports/factory-settlements',
        name: 'fnReportsFactorySettlements',
        component: () => import('@/views/fnReports/factorySettlements')
      },
      {
        path: 'fn-reports/factory-settlements-new/:title',
        name: 'fnReportsFactorySettlementsNew',
        component: () => import('@/views/fnReports/factorySettlements/new.vue')
      },
      {
        path: 'fn-reports/worker-salaries',
        name: 'fnReportsWorkerSalaries',
        component: () => import('@/views/fnReports/workerSalaries')
      },
      {
        path: 'fn-reports/worker-salaries/batch-edit-item/:id',
        name: 'fnReportsWorkerSalariesBatchEditItem',
        component: () => import('@/views/fnReports/workerSalaries/batchEditItem')
      },
      {
        path: 'fn-reports/material-settlements',
        name: 'fnReportsMaterialSettlements',
        component: () => import('@/views/fnReports/materialSettlements')
      },
      {
        path: 'fn-reports/material-settlements-new/:title',
        name: 'fnReportsMaterialSettlementsNew',
        component: () => import('@/views/fnReports/materialSettlements/new.vue')
      },
      {
        path: 'fn-reports/sale-settlements',
        name: 'fnReportsSaleSettlements',
        component: () => import('@/views/fnReports/saleSettlements')
      },
      {
        path: 'fn-reports/sale-settlements/new/:title',
        name: 'fnReportsSaleSettlementsNew',
        component: () => import('@/views/fnReports/saleSettlements/new')
      },

      //=============
      {
        path: 'fn-reports/reports/cost-profit',
        name: 'fnReportsReportsCostProfit',
        component: () => import('@/views/fnReports/reports/costProfit')
      },
      {
        path: 'fn-reports/reports/return-detail',
        name: 'fnReportsReportsReturnDetail',
        component: () => import('@/views/fnReports/reports/returnDetail')
      },
      {
        path: 'fn-reports/reports/payment-detail',
        name: 'fnReportsReportsPaymentDetail',
        component: () => import('@/views/fnReports/reports/paymentDetail')
      },
      //============
      {
        path: 'fn-reports/reports/synthesize/cost-profit',
        name: 'fnReportsReportsSynthesizeCostProfit',
        component: () => import('@/views/fnReports/reports/synthesize/costProfit')
      },
      {
        path: 'fn-reports/reports/mes/qa',
        name: 'fnReportsReportsMesQa',
        component: () => import('@/views/fnReports/reports/mes/qa')
      },
      {
        path: 'fn-reports/reports/oms/payment-detail',
        name: 'fnReportsReportsOmsPaymentDetail',
        component: () => import('@/views/fnReports/reports/oms/paymentDetail')
      },
      {
        path: 'fn-reports/reports/oms/wholesale-customer-ranking',
        name: 'fnReportsReportsOmsWholesaleCustomerRanking',
        component: () => import('@/views/fnReports/reports/oms/wholesaleCustomerRanking')
      },
      {
        path: 'fn-reports/reports/oms/product-sale-ranking',
        name: 'fnReportsReportsOmsProductSaleRanking',
        component: () => import('@/views/fnReports/reports/oms/productSaleRanking')
      },
      {
        path: 'fn-reports/reports/oms/sale-performance',
        name: 'fnReportsReportsOmsSalePerformance',
        component: () => import('@/views/fnReports/reports/oms/salePerformance')
      },
      {
        path: 'fn-reports/reports/oms/sale-performance/diff-detail',
        name: 'fnReportsReportsOmsSalePerformanceDiffDetail',
        component: () => import('@/views/fnReports/reports/oms/salePerformance/diffDetail')
      },
      {
        path: 'fn-reports/reports/oms/sale-performance/sale-amount-detail',
        name: 'fnReportsReportsOmsSalePerformanceSaleAmountDetail',
        component: () => import('@/views/fnReports/reports/oms/salePerformance/saleAmountDetail')
      },
      {
        path: 'fn-reports/reports/oms/sale-performance/pay-amount-detail',
        name: 'fnReportsReportsOmsSalePerformancePayAmountDetail',
        component: () => import('@/views/fnReports/reports/oms/salePerformance/payAmountDetail')
      },
      {
        path: 'fn-reports/reports/oms/sale-line-chart',
        name: 'fnReportsReportsOmsSaleLineChart',
        component: () => import('@/views/fnReports/reports/oms/saleLineChart')
      },
      {
        path: 'fn-reports/reports/oms/diff-detail',
        name: 'fnReportsReportsOmsDiffDetail',
        component: () => import('@/views/fnReports/reports/oms/diffDetail')
      },
      {
        path: 'fn-reports/reports/pms/purchase-detail',
        name: 'fnReportsReportsPmsPurchaseDetail',
        component: () => import('@/views/fnReports/reports/pms/purchaseDetail')
      },
      {
        path: 'fn-reports/reports/pms/supplier-over',
        name: 'fnReportsReportsPmsSupplierOver',
        component: () => import('@/views/fnReports/reports/pms/supplierOver/index')
      },
      {
        path: 'fn-reports/reports/pms/supplier-over/detail',
        name: 'fnReportsReportsPmsSupplierOverDetail',
        component: () => import('@/views/fnReports/reports/pms/supplierOver/detail')
      },


      {
        path: 'fn-reports/reports/wms/inventory-count',
        name: 'fnReportsReportsWmsInventoryCount',
        component: () => import('@/views/fnReports/reports/wms/inventoryCount')
      },
      {
        path: 'fn-reports/reports/wms/moving-pin-rate',
        name: 'fnReportsReportsWmsMovingPinRate',
        component: () => import('@/views/fnReports/reports/wms/movingPinRate')
      },


    ]
  },
  {
    path: '/mall',
    name: 'mall',
    component: () => import('@/layouts/MALL.vue'),
    children: [
      {
        path: 'mall',
        name: 'mall',
        component: () => import('@/views/mall/index.vue')
      },
      {
        path: 'mall/bargains',
        name: 'mallBargains',
        component: () => import('@/views/mall/bargains/index.vue')
      },
      {
        path: 'mall/products',
        name: 'mallProducts',
        component: () => import('@/views/mall/products/index.vue')
      },
      {
        path: 'mall/categories',
        name: 'mallCategories',
        component: () => import('@/views/mall/categories/index.vue')
      },
      {
        path: 'mall/serials',
        name: 'mallSerials',
        component: () => import('@/views/mall/serials/index.vue')
      },
      {
        path: 'mall/settings',
        name: 'mallSettings',
        component: () => import('@/views/mall/settings/index.vue')
      },
    ]
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/Help.vue')
  },
  {
    path: '/*',
    name: '404',
    component: () => import('@/views/404.vue')
  }
]
const routes2 = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard'),
  },

]

const router = new VueRouter({
  mode: 'history',
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
